import { DateTime } from "luxon";

export function defaultMonthRange(): { end: string; start: string } {
  const start = DateTime.now().startOf("month").toISODate() ?? "";
  const end = DateTime.now().endOf("month").toISODate() ?? "";
  return { start, end };
}
